import {
  HorizontalAlignmentType,
  PDF_BLOCK_TEXT_FIELD_TYPES,
  PDF_VERTICAL_ALIGNMENT_EXCLUDED_TYPES,
  VerticalAlignmentType,
} from 'constants/forms';

export const findOptionByValue = (options, value) => options.find(option => option.value === value);

export const getInitialHorizontalAlignment = ({ align, isNewItem }) => ({
  value: align || (isNewItem ? HorizontalAlignmentType.CENTER : HorizontalAlignmentType.LEFT),
});

export const getInitialVerticalAlignment = ({ verticalAlign }) => ({
  value: verticalAlign || VerticalAlignmentType.MIDDLE,
});

// The PDF renderer centers single-line text by default and top-anchors block text, so the
// editor preview mirrors that even for fields saved before verticalAlign existed.
export const getPreviewVerticalAlign = ({ type, verticalAlign }) => {
  if (PDF_BLOCK_TEXT_FIELD_TYPES.includes(type)) {
    return VerticalAlignmentType.TOP;
  }

  if (PDF_VERTICAL_ALIGNMENT_EXCLUDED_TYPES.includes(type)) {
    return null;
  }

  return verticalAlign || VerticalAlignmentType.MIDDLE;
};
